import { createFileRoute } from "@tanstack/react-router";
import { DestinationsPage, buildDestinationsSchemas } from "@/components/DestinationsPage";
import { buildHead } from "@/content/seo";

const PATH = "/destinations";
const URL = "https://vilamouradreamscruises.com" + PATH;
const TITLE = "Algarve Destinations — 40+ Places We Sail To | Vilamoura Dreams Cruises";
const DESC =
  "The full guide to 40+ Algarve destinations reached by private yacht from Marina de Vilamoura — Benagil, Ponta da Piedade, Ria Formosa, Silves, Cacela Velha — with distances and landing notes.";

export const Route = createFileRoute("/destinations")({
  component: () => <DestinationsPage lang="en" />,
  head: () =>
    buildHead({
      lang: "en",
      path: PATH,
      title: TITLE,
      description: DESC,
      keywords:
        "algarve destinations yacht, benagil cave, ponta da piedade, ria formosa cruise, silves rio arade, cacela velha, private yacht charter vilamoura",
      altPath: { en: PATH, pt: "/pt/destinos" },
      extraScripts: buildDestinationsSchemas("en", URL).map((s) => ({
        type: "application/ld+json",
        children: JSON.stringify(s),
      })),
    }),
});